// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4305":"cf2d5117","7073":"4ad12d36"}[chunkId] + ".css";
};